import React from "react";

/**
 * VETRICH TECHNOLOGIES brand logo — uses the user-uploaded artwork
 * located at /brand/vetrich-logo.png (served from public/).
 *
 * Props:
 *   size: pixel height of the logo (default 48)
 *   tone: "light" | "dark"  → applies subtle backdrop for dark backgrounds
 *   className: extra classes
 */
export default function VetrichLogo({
  size = 48,
  tone = "dark",
  className = "",
  ...rest
}) {
  const isLight = tone === "light";
  return (
    <img
      src="/brand/vetrich-logo.png"
      alt="Vetrich Technologies"
      height={size}
      style={{
        height: `${size}px`,
        width: "auto",
        objectFit: "contain",
        filter: isLight ? "drop-shadow(0 2px 12px rgba(0,0,0,0.35))" : "none",
      }}
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
